<div class="campaign-container redeemed-border cursor-pointer">
  <img [campaignImage]="campaignEntitlement.CampaignId" alt="" class="campaign-img" />

  <div class="campaign-details">
    <div class="font-size-12 text-white">{{ campaignEntitlement.CampaignName }}</div>
    <ng-container *ngIf="voucherEntitlement.RedemptionDate; else showExpiry">
      <div class="font-size-12 text-white gap-1">
        <span>{{ 'offer.claimed' | translate }}</span>:
        <span>{{ voucherEntitlement.RedemptionDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}</span>
      </div>
    </ng-container>
    <ng-template #showExpiry>
      <ng-container *ngIf="!campaignEntitlement.Claimed || isVoucher">
        <div class="campaign-list-item-expiry-date font-size-12 gap-1">
          <span class="text-uppercase">{{ 'offer.expired' | translate }}</span>:
          <span>{{ expiryDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}</span>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
